import React, { useState } from "react";
import { Car, Phone, Mail, Video, PauseCircle } from "lucide-react";

const META = {
  VISIT: { label: "Visit", icon: Car, cls: "bg-teal-50 text-teal-700 border-teal-200" },
  PHONE: { label: "Phone", icon: Phone, cls: "bg-sky-50 text-sky-700 border-sky-200" },
  EMAIL: { label: "Email", icon: Mail, cls: "bg-violet-50 text-violet-700 border-violet-200" },
  VIDEO_DEMO: { label: "Video demo", icon: Video, cls: "bg-fuchsia-50 text-fuchsia-700 border-fuchsia-200" },
  WAIT: { label: "Wait", icon: PauseCircle, cls: "bg-slate-100 text-slate-500 border-slate-200" },
};

/** Displays the server-computed channel recommendation. Tap/hover reveals reasons.
 * Never re-derives channel logic — consumes `recommend_channel` output. */
export function ChannelBadge({ channel, reasons = [], testid }) {
  const [open, setOpen] = useState(false);
  const m = META[channel] || META.WAIT;
  const Icon = m.icon;
  return (
    <span className="relative inline-flex" onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)}>
      <span
        role="button"
        tabIndex={0}
        data-testid={testid || `channel-badge-${channel}`}
        onClick={(e) => { e.stopPropagation(); setOpen((v) => !v); }}
        className={`inline-flex cursor-pointer items-center gap-1 rounded-full border px-2 py-0.5 text-[11px] font-bold ${m.cls}`}
      >
        <Icon className="h-3 w-3" /> {m.label}
      </span>
      {open && reasons.length > 0 && (
        <span
          data-testid={`${testid || `channel-badge-${channel}`}-reasons`}
          className="absolute right-0 top-full z-20 mt-1 w-56 rounded-lg border border-slate-200 bg-white p-2 text-left text-[11px] text-slate-600 shadow-lg"
        >
          <span className="mb-1 block font-semibold uppercase tracking-wide text-slate-400">Why</span>
          <ul className="space-y-0.5">
            {reasons.map((r, i) => (
              <li key={i} className="flex items-start gap-1"><span className="mt-1 h-1 w-1 shrink-0 rounded-full bg-teal-400" /> {r}</li>
            ))}
          </ul>
        </span>
      )}
    </span>
  );
}
